import { render } from "./yxRadarChart.vue?vue&type=template&id=984914bc&scoped=true"
import script from "./yxRadarChart.vue?vue&type=script&lang=js"
export * from "./yxRadarChart.vue?vue&type=script&lang=js"

import "./yxRadarChart.vue?vue&type=style&index=0&id=984914bc&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984914bc"]])

export default __exports__